// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "last-modified-date-module--bx--text-truncate--end--QgCc7";
export var bxTextTruncateFront = "last-modified-date-module--bx--text-truncate--front--kel8a";
export var row = "last-modified-date-module--row--XJoYQ";
export var text = "last-modified-date-module--text--ogPQF";